import { Flex, Heading, Text, VStack, Button, Input } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import FormField from 'design-system/molecules/form-field';
import { useOnboardContractorExisting } from '../../data/useOnboardContractorExisting';
import { pathDashboard } from '../../constants/path';

export default function OnboardNewOrgExistContractorUser() {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm<{ orgName: string }>();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const onboardContractorExistingHandler = useOnboardContractorExisting();
  const onSubmit = async (data: { orgName: string }) => {
    await onboardContractorExistingHandler.onboardContractorExistingUser(
      data.orgName
    );
    navigate(`${pathDashboard()}`);
  };
  return (
    <Flex bgColor="white" justify="center" align="center" p={8}>
      <VStack width={{ sm: '768px' }} gap={8} align="flex-start">
        <VStack gap={4} align="flex-start">
          <Heading fontSize="5xl">
            <FormattedMessage
              defaultMessage="Create new organisation"
              id="X0fA35"
            />
          </Heading>
          <Text fontSize="2xl">
            <FormattedMessage
              defaultMessage="Start an account with Mooven"
              id="2wU1Cd"
            />
          </Text>
        </VStack>
        <VStack gap={4} align="flex-start">
          <Text fontSize="sm" fontWeight="700">
            <FormattedMessage defaultMessage="Organisation name" id="tQmCCq" />
          </Text>
          <FormField
            isInvalid={!!errors.orgName}
            errorText={errors.orgName?.message}
          >
            <Input
              focusBorderColor="green.500"
              type="text"
              placeholder="Organisation name"
              {...register('orgName', {
                required: formatMessage({
                  defaultMessage: 'Please enter organisation name',
                  id: '/3xveu',
                  description: 'Error message for organisation name',
                }),
              })}
            />
          </FormField>
          <Button
            variant="solid"
            colorScheme="brand"
            onClick={handleSubmit(onSubmit)}
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
          >
            <FormattedMessage defaultMessage="Create" id="VzzYJk" />
          </Button>
        </VStack>
      </VStack>
    </Flex>
  );
}
